/* Angular Component */
import { Component, Input, ElementRef } from "@angular/core";
import { Routes } from "@angular/router";

@Component({
  selector: "back-button",
  templateUrl: "./backButton.component.html",
  styleUrls: ["./backButton.component.scss"],
})
export class BackButtonComponent {
  @Input()
  title;

  @Input()
  backgroundClass: string = "bg-white";

  @Input()
  url;
}
